import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  private cache: {[name: string]: Observable<string>} = {};

  constructor(
    private http: HttpClient
  ) {
  }

  getIcon(name: string, isFullUrl: boolean = false): Observable<string> {
    if (this.cache[name]) {
      return this.cache[name];
    }

    let url = name;
    if (!isFullUrl) url = `/assets/images/${name}.svg`

    const obs = this.http.get(url, { responseType: 'text' }).pipe(
      shareReplay()
    );

    this.cache[name] = obs;
    return obs;
  }
}
